import React, { FC } from 'react';
import Col from 'react-bootstrap/lib/Col';

import { BaseCardProps } from './interfaces';

const BaseCard: FC<BaseCardProps> = ({ title, body, color = 'orange' }) => {
  return (
    <Col xs={12} sm={6} lg={4} className="form-group">
      <Col xs={12} className={`card card-${color}`}>
        <h3 className="card-title">{title}</h3>
        <div className="card-body">
          <div className="card-body-inside">{body}</div>
        </div>
      </Col>
    </Col>
  );
};

export default BaseCard;
